// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"W6f_Jw"};